import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.lenis) {
      window.lenis.scrollTo(0, {
        immediate: true,
      });
    }
  }, [location]);

  return null;
};

export default ScrollToTop;